function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgWechat(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M71.782 45.969C71.781 31.098 57.475 19 39.891 19 22.306 19 8 31.098 8 45.969c0 4.781 1.48 9.439 4.292 13.538l2.31 16.546a4 4 0 005.86 2.969l12.484-6.73c2.288.43 4.617.647 6.946.647 17.584-.001 31.89-12.099 31.89-26.97zM39.891 64.938c-2.239 0-4.479-.255-6.658-.759a4.007 4.007 0 00-2.798.376l-8.706 4.693-1.65-11.821a4.001 4.001 0 00-.757-1.841C17.149 52.677 16 49.352 16 45.969 16 35.51 26.717 27 39.891 27c13.172 0 23.89 8.51 23.891 18.969 0 10.46-10.718 18.969-23.891 18.969z"
  }), React.createElement("path", {
    d: "M76.72 32.322a3.997 3.997 0 00-5.042 2.564 3.999 3.999 0 002.563 5.042c7.255 2.364 9.826 5.687 9.826 12.697 0 2.168-.762 4.312-2.204 6.2a4.015 4.015 0 00-.804 2.05l-.562 5.921-6.076-2.075a4.019 4.019 0 00-2.177-.116 14.52 14.52 0 00-.725.192c-.85.241-2.271.646-4.559.646a4 4 0 000 8c2.782 0 4.8-.43 6.036-.755l9.71 3.316a3.999 3.999 0 005.275-3.407l.939-9.893c2.062-3.063 3.146-6.524 3.146-10.079.001-10.439-4.876-16.891-15.346-20.303z"
  }), React.createElement("circle", {
    cx: 32.625,
    cy: 45.5,
    r: 3.75
  }), React.createElement("circle", {
    cx: 45.75,
    cy: 45.5,
    r: 3.75
  }));
}

SvgWechat.clsName = 'icon-www__wechat';
SvgWechat.remarkName = 'unknown';
export default SvgWechat;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Wechat.js
// module id = 2538
// module chunks = 17 18